import * as actions from "./actions";
import { Map, fromJS } from "immutable";

function reducer(state = Map(), action) {
  switch (action.type) {
    // ========= COMPANY ============
    case actions.SET_COMPANIES_INFO:
      return fromJS(action.payload);
    case actions.SET_COMPANY_INFO:
      return state.set(String(action.company.id), fromJS(action.company));
    case actions.DELETE_COMPANY:
      return state.delete(String(action.companyId));
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// src/model/Company/reducer.js